import { render } from "./MeasureUnitSelect.vue?vue&type=template&id=0fc8123a"
import script from "./MeasureUnitSelect.vue?vue&type=script&lang=js"
export * from "./MeasureUnitSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__